<template lang="html">
  <div class="attendance-guide-print">
    <div class="content" v-if="attendanceGuide.appointment != null">
      <div class="transaction-form main-content-cj h-100 mh-100">
        <b-container class="d-flex flex-column h-100 mh-100">
          <b-row class="mb-2">
            <b-col class="d-flex align-items-center">
              <img v-if="logo != null" :src="logo" height="60" class="ml-1 mr-2" :alt="user.person.client.name" />
              <div class="clinic-header mx-1">
                <p class="clinic-name mb-0">{{user.person.client.name}}</p>
                <p class="mb-0">{{user.person.client.document}}</p>
                <p class="mb-0"><i class="fal fa-map-marker-alt mr-1"></i>{{getFormattedFullAddress(user.person.client.address)}}</p>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="header text-center py-3">
                <p class="title mb-0">Guia de Atendimento</p>
              </div>
              <table class="table table-responsive" style="display: table">
                <thead>
                  <tr class="thead">
                    <th>Guia</th>
                    <th>Data do atendimento</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ attendanceGuide.internal_id }}</td>
                    <td>{{ moment(attendanceGuide.appointment.start_datetime).format('DD/MM/YY HH:mm') }}</td>
                    <td>{{ attendanceGuide.pending?'Aberta':'Fechada' }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="sub-header px-2 py-2">
                <p class="title mb-0">Dados do Beneficiário</p>
              </div>
              <table class="table table-responsive" style="display: table">
                <thead>
                <tr class="thead">
                  <th>Nome</th>
                  <th>Convênio</th>
                  <th>Número da Carteira</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{ attendanceGuide.patient.name.toUpperCase() }}</td>
                  <td>{{ attendanceGuide.health_plan.name }}</td>
                  <td>{{ attendanceGuide.card_number != null ? attendanceGuide.patient.card_number : (attendanceGuide.health_plan.name !== 'Particular' && attendanceGuide.patient.card_number != null ? attendanceGuide.patient.card_number : '-') }}</td>
                </tr>
                </tbody>
              </table>

              <div class="sub-header px-2 py-2">
                <p class="title mb-0">Dados do Solicitante</p>
              </div>
              <table class="table table-responsive" style="display: table">
                <thead>
                  <tr class="thead">
                    <th>Nome do Profissional Solicitante</th>
                    <th>Núm. no Conselho</th>
<!--                    <th>Código na Operadora</th>-->
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ attendanceGuide.appointment.professional.name.toUpperCase() }}</td>
                    <td>{{ attendanceGuide.appointment.professional.professional_registration != null ? attendanceGuide.appointment.professional.professional_registration.number : '-' }}</td>
<!--                    <td>????</td>-->
                  </tr>
                </tbody>
              </table>

              <div class="sub-header px-2 py-2">
                <p class="title mb-0">Dados da Solicitação / Procedimentos e Exames Solicitados</p>
              </div>
              <table class="table table-responsive" style="display: table">
                <thead>
                  <tr class="thead">
                    <th>Código do<br>Procedimento</th>
                    <th>Descrição</th>
                    <th>Quantidade<br>Solicitada</th>
                    <th>Quantidade<br>Autorizada</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) of attendanceGuide.items" :key="index">
                    <td>{{ item.procedure.tuss_code ? item.procedure.tuss_code : item.procedure.internal_code }}</td>
                    <td>{{ getItemDescription(item) }}</td>
                    <td>{{ item.amount }}</td>
                    <td>{{ item.accomplished ? item.amount : 0 }}</td>
                    <td>R$ {{ formatPrice(item.value) }}</td>
                  </tr>
                </tbody>
              </table>
              <hr class="mb-4">


              <hr class="signature ml-2">
              <p class="px-2">{{ attendanceGuide.patient.name.toUpperCase() }}</p>

              <p class="mt-4">Guia gerada através do Consulta Já</p>
            </b-col>
          </b-row>
        </b-container>
      </div>


    </div>
  </div>
</template>

<script lang="js">
export default {
  data () {
    return {
      leavingPage: false,
      user: JSON.parse(localStorage.getItem('user')),
      logo: null,

      dischargedTerm: 'pago',

      attendanceGuide: {
        id: null,
        appointment_id: null,
        appointment: null,
        start_datetime: '',
        internal_id: '',
        name: '',
        health_plan: '',
        pending: true,
        items: []
      }
    }
  },
  async mounted() {
    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          return;
        }
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          this.isLoading.hide();
          this.isLoading = null;
        }
      }
    });

    this.eventBus.$emit('IS_LOADING', true);

    this.logo = this.user.person.client.logo ? this.user.person.client.logo : null;
    await this.api.getAttendanceGuide(this.$route.params.id).then(res => {
      this.eventBus.$emit('IS_LOADING', false);
      if(this.leavingPage) {
        return;
      }

      this.attendanceGuide = res.data;
      setTimeout(function (){
        window.print();
      }, 250);

      if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        console.log('Response Attendance Guide', res);
    }).catch(err => {
      this.eventBus.$emit('IS_LOADING', false);
      if(this.leavingPage) {
        return;
      }

      this.$swal('Ops...', 'Não conseguimos carregar esta guia de atendimento! Por favor, entre em contato com o suporte!', 'error');
      if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
        console.log('Error Attendance Guide', err.response);
    });
  },
  methods: {
    getItemDescription(item) {
      let description = item.procedure.name;
      if(item.tooth != null) {
        let isTooth = typeof item.tooth === 'number' || !isNaN(item.tooth);
        description += ' - ' + (isTooth ? 'Dente ' : '') + item.tooth;
        if(item.faces != null) {
          description += ', Face(s) ' + item.faces;
        }
      }
      return description;
    },

    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    getFormattedFullAddress(address) {
      if(address == null) {
        return '-';
      }
      let formattedAddress = address.address;
      if(address.number != null) {
        formattedAddress += ', ' + address.number;
      }
      if(address.complement != null) {
        formattedAddress += ', ' + address.complement;
      }
      if(address.neighborhood != null) {
        formattedAddress += ', ' + address.neighborhood;
      }
      if(address.city != null && address.state != null) {
        formattedAddress += ' - ' + address.city + ', ' + address.state.toUpperCase();
      }
      return formattedAddress;
    }
  },
  beforeRouteLeave (to, from, next) {
    this.leavingPage = true;
    next();
  }
}
</script>

<style scoped lang="scss">
  .attendance-guide-print {
    display: flex;
    overflow: hidden;
    min-height: 100vh;

    .content {
      flex: 1;
      height: 100vh;
      overflow: scroll;
      overflow-x: hidden;
    }

    .clinic-header {
      font-size: 15px;
      font-family: 'sf_pro_displayregular';

      .clinic-name {
        font-size: 16px;
        font-family: 'sf_pro_displaysemibold';
      }

      i {
        font-size: 14px;
      }
    }

    .header {
      background: #999;

      .title {
        color: #fff;
        font-size: 18px;
      }
    }
    .sub-header {
      background: #c3cbcf;

      .title {
        color: #000;
        font-size: 15px;
      }
    }
    .table {
      margin-top: 10px;
      font-size: 15px;
      font-family: 'sf_pro_displayregular';
      th {
        font-family: 'sf_pro_displaysemibold';
        padding: 4px 10px;
        border: 0;
        vertical-align: middle;
      }
      td {
        padding: 4px 10px;
        border: 0;
        vertical-align: middle;
      }
    }
    .signature {
      border-color: #000;
      width: 45%;
      margin-top: 60px;
      margin-bottom: 8px;
    }

    @media (min-width: 1200px) {
      .container {
        max-width: 100%;
      }
    }
  }

  .widget-visible {
    display: none!important;
  }

  @media (max-width: 767px) {
    .attendance-guide-print {
      flex-flow: column wrap;
    }

    .content {
      margin-top: 96px;
      height: calc(100vh - 96px) !important;
    }
  }

  @media print {
    aside {
      display: none;
    }

    .content {
      background-color: #ffffff !important;
      height: auto !important;
    }
  }
</style>
